import React, { useEffect, useState } from "react";
import { Card, Dropdown, Nav } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getTaskById } from "../../services/tasks/tasks";
import BoardDnd from "../board-dnd/board-dnd";
import Board from "../High priority/Board";
import InviteMembers from "../InviteMembers/InviteMembers";
import Members from "../members/Members";
import Task from "../Task/Task";
import TrelloBoard from "../trello-board/Home/Dash";
import "./roadmap.scss";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { getAllData } from "../../services/tasks/tasks";
import { setSearchData } from "../../store/BoardsData";
import { useSelector, useDispatch } from "react-redux";

export default function Roadmap() {
  const [apiTask, setApiTask] = useState({});
  const [tabeName, setTabName] = useState("trello");
  const [search, setSearch] = useState();
  const [serachTitle, setSearchTitle] = useState("");
  const [getData, setGetData] = useState([]);
  const [name, setName] = useState([]);
  console.log("id name:", name);
  let { id } = useParams();

  const users = getData.slice(0, 3);
  console.log("users :", users);
  const allBoards = useSelector((state) => state.BoardsData.tatalCards);
  const dispatch = useDispatch();
  console.log("all boards .................", allBoards);
  //  const allBoards=0
  const getApiData = () => {
    getAllData()
      .then((res) => {
        console.log("res of filtered before :", res);
        let filterData = res.data.data.filter((item) => {
          return item.userId[0] === localStorage.getItem("userId")
        });
        console.log("res in roadmap for members  : ", filterData);
        setName(filterData[0].title);
        setGetData(filterData[0].member);
      })
      .catch((e) => {
        console.error("Err :", e);
      });
  };
  useEffect(() => {
    getApiData();
  }, []);

  const searchHandle = (searchValue) => {
    const filterData =
      allBoards &&
      allBoards.filter((elm, index) => {
        console.log("search data ,", searchValue);
        console.log("elm title :", elm);
        return elm.cards.find((card, i) => {
          //  console.log("card :",card)

          return card.title.startsWith(searchValue);
        });
        // return elm.title.toLowerCase()==serachTitle.toLowerCase();
      });
    console.log("filter DAta :", filterData);
    dispatch(setSearchData(filterData));
  };

  return (
    <>
      <Card className="card-card">
        <Card.Header
          style={{ backgroundColor: "rgb(77, 75, 75)", border: "none" }}
        >
          <Nav variant="tabs" defaultActiveKey="#first">
            <div className="boarName mt-2">
              <p className="text-light">{name}</p>
            </div>
            <Nav.Item>
              <Nav.Link
                onClick={() => setTabName("trello")}
                className="form-border mt-1"
              >
                Boards
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                onClick={() => setTabName("members")}
                className="form-border mt-1"
              >
                Members
              </Nav.Link>
            </Nav.Item>

            {/* <Nav.Item>
              <Nav.Link
                onClick={() => setTabName("newboard")}
                className="form-border"
              >
                New Board
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                onClick={() => setTabName("table")}
                className="form-border"
              >
                Tables
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                onClick={() => setTabName("board")}
                className="form-border"
              >
                Board
              </Nav.Link>
            </Nav.Item> */}

            <Nav.Item className="mt-1">
              <InviteMembers />
            </Nav.Item>
            <Nav.Item style={{ display: "flex" }}>
              {users?.map((item, index) => {
                return (
                  <div key={index} className="members__mainDiv">
                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{item.email}</Tooltip>}>
                      {
                        item?.profilePicture ? (
                          <img src={`${process.env.REACT_APP_API_URL_IMG}/${item.profilePicture}`} alt="" className="pc" />
                        ) : <p
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            backgroundColor: "#00d4ff",
                            color: "white",
                            marginRight: "10px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                          }}
                        >
                          {item.email.charAt(0)}
                        </p>
                      }
                    </OverlayTrigger>
                    {index === 2 && (
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-basic"
                          style={{
                            backgroundColor: "grey",
                            border: "none",
                            color: "white",
                            fontSize: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          +{getData.length - 3}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {getData?.map((item, index) => {
                            return (
                              index > 2 && (
                                <Dropdown.Item key={index}>
                                  <p>{item.email}</p>
                                </Dropdown.Item>
                              )
                            );
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </div>
                );
              })}
            </Nav.Item>
            {/* <div>  <input type="serach" className="form-control" placeholder="search board or members" onChange={(e) => { searchHandle(e.target.value) }} ></input></div> */}
          </Nav>
        </Card.Header>
      </Card>
      {tabeName === "trello" && <TrelloBoard apiTask={apiTask} />}
      {tabeName === "newboard" && <BoardDnd apiTask={apiTask} />}
      {tabeName === "table" && <Task apiTask={apiTask} />}
      {tabeName === "board" && <Board apiTask={apiTask} />}
      {tabeName === "members" && <Members apiTask={apiTask} />}
    </>
  );
}
